(function () {
  var DRAWER_MS = 700;
  var DRAWER_RUBBER_MAX = 72;
  var DRAWER_RUBBER_RESISTANCE = 0.45;

  function getPanel(el) {
    return el.querySelector('.drawer__inner');
  }

  function getOverlay(el) {
    return el.querySelector('.cart-drawer__overlay');
  }

  function createDrawerController(el) {
    var state = {
      lastFocused: null,
      closing: false,
      ghostClickBlockUntil: 0,
      rubberY: 0,
      lastTouchY: 0,
      openTransitionHandler: null,
      closeTransitionHandler: null,
    };

    function getDrawerScrollEl() {
      return el.querySelector('.rn-bag__scroll');
    }

    function scrollElCanScroll(scrollEl) {
      if (!scrollEl) return false;
      return scrollEl.scrollHeight > scrollEl.clientHeight + 1;
    }

    function getDrawerRubberEl() {
      return el.querySelector('.rn-bag__content') || getDrawerScrollEl();
    }

    function setDrawerRubberOffset(y) {
      var rubberEl = getDrawerRubberEl();
      if (!rubberEl) return;
      rubberEl.style.transform = y ? 'translate3d(0,' + y + 'px,0)' : '';
    }

    function resetDrawerRubber(animate) {
      var rubberEl = getDrawerRubberEl();
      state.rubberY = 0;
      if (!rubberEl) return;
      if (animate) {
        rubberEl.style.transition = 'transform 0.4s cubic-bezier(0.16, 1, 0.3, 1)';
        setDrawerRubberOffset(0);
        window.setTimeout(function () {
          rubberEl.style.transition = '';
        }, 400);
      } else {
        rubberEl.style.transition = 'none';
        setDrawerRubberOffset(0);
      }
    }

    function onDrawerRubberTouchStart(e) {
      if (!e.touches || !e.touches.length) return;
      state.lastTouchY = e.touches[0].clientY;
      var rubberEl = getDrawerRubberEl();
      if (rubberEl) rubberEl.style.transition = 'none';
    }

    function onDrawerRubberTouchMove(e) {
      var scrollEl = getDrawerScrollEl();
      if (!scrollEl || !e.touches || !e.touches.length) return;

      var currentY = e.touches[0].clientY;
      var deltaY = currentY - state.lastTouchY;
      state.lastTouchY = currentY;
      var canScroll = scrollElCanScroll(scrollEl);
      var atTop = scrollEl.scrollTop <= 0;
      var atBottom = scrollEl.scrollTop + scrollEl.clientHeight >= scrollEl.scrollHeight - 1;

      if (canScroll && !atTop && !atBottom) {
        return;
      }

      if (state.rubberY > 0) {
        state.rubberY = Math.max(0, state.rubberY + deltaY * DRAWER_RUBBER_RESISTANCE);
        if (state.rubberY > 0) {
          e.preventDefault();
          setDrawerRubberOffset(state.rubberY);
        } else {
          resetDrawerRubber(false);
        }
        return;
      }

      if (state.rubberY < 0) {
        state.rubberY = Math.min(0, state.rubberY + deltaY * DRAWER_RUBBER_RESISTANCE);
        if (state.rubberY < 0) {
          e.preventDefault();
          setDrawerRubberOffset(state.rubberY);
        } else {
          resetDrawerRubber(false);
        }
        return;
      }

      if (atTop && deltaY > 0) {
        e.preventDefault();
        state.rubberY = Math.min(DRAWER_RUBBER_MAX, deltaY * DRAWER_RUBBER_RESISTANCE);
        setDrawerRubberOffset(state.rubberY);
        return;
      }

      if (atBottom && deltaY < 0) {
        e.preventDefault();
        state.rubberY = Math.max(-DRAWER_RUBBER_MAX, deltaY * DRAWER_RUBBER_RESISTANCE);
        setDrawerRubberOffset(state.rubberY);
      }
    }

    function onDrawerRubberTouchEnd() {
      if (state.rubberY !== 0) resetDrawerRubber(true);
    }

    function isInsideDrawerPanel(target) {
      var panel = getPanel(el);
      return !!(panel && target && panel.contains(target));
    }

    function onDocumentTouchMove(e) {
      if (isInsideDrawerPanel(e.target)) return;
      e.preventDefault();
    }

    function onDocumentWheel(e) {
      if (!el.classList.contains('is-open')) return;
      if (isInsideDrawerPanel(e.target)) return;
      e.preventDefault();
    }

    function lockPageScroll() {
      document.body.classList.remove('overflow-hidden');
      document.addEventListener('touchmove', onDocumentTouchMove, { passive: false });
      document.addEventListener('wheel', onDocumentWheel, { passive: false });
    }

    function unlockPageScroll() {
      document.removeEventListener('touchmove', onDocumentTouchMove);
      document.removeEventListener('wheel', onDocumentWheel);
      document.body.classList.remove('overflow-hidden');
    }

    function onDrawerWheel(e) {
      var scrollEl = getDrawerScrollEl();
      if (!scrollEl || !scrollEl.contains(e.target)) return;

      var atTop = scrollEl.scrollTop <= 0;
      var atBottom = scrollEl.scrollTop + scrollEl.clientHeight >= scrollEl.scrollHeight - 1;

      if ((atTop && e.deltaY < 0) || (atBottom && e.deltaY > 0)) {
        e.preventDefault();
      }
    }

    function bindDrawerScrollGuards() {
      var scrollEl = getDrawerScrollEl();
      if (!scrollEl || scrollEl.dataset.rnBagScrollBound === '1') return;
      scrollEl.dataset.rnBagScrollBound = '1';
      scrollEl.addEventListener('touchstart', onDrawerRubberTouchStart, { passive: true });
      scrollEl.addEventListener('touchmove', onDrawerRubberTouchMove, { passive: false });
      scrollEl.addEventListener('touchend', onDrawerRubberTouchEnd, { passive: true });
      scrollEl.addEventListener('touchcancel', onDrawerRubberTouchEnd, { passive: true });
      scrollEl.addEventListener('wheel', onDrawerWheel, { passive: false });
    }

    function unbindDrawerScrollGuards() {
      el.querySelectorAll('.rn-bag__scroll, .rn-bag__content-container').forEach(function (scrollEl) {
        scrollEl.removeEventListener('touchstart', onDrawerRubberTouchStart);
        scrollEl.removeEventListener('touchmove', onDrawerRubberTouchMove);
        scrollEl.removeEventListener('touchend', onDrawerRubberTouchEnd);
        scrollEl.removeEventListener('touchcancel', onDrawerRubberTouchEnd);
        scrollEl.removeEventListener('wheel', onDrawerWheel);
        delete scrollEl.dataset.rnBagScrollBound;
      });
      resetDrawerRubber(false);
    }

    function blockGhostClick(e) {
      if (Date.now() < state.ghostClickBlockUntil) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
      } else {
        document.removeEventListener('click', blockGhostClick, true);
        document.removeEventListener('touchend', blockGhostClick, true);
      }
    }

    function armGhostClickBlock() {
      state.ghostClickBlockUntil = Date.now() + DRAWER_MS + 100;
      document.addEventListener('click', blockGhostClick, true);
      document.addEventListener('touchend', blockGhostClick, true);
    }

    function focusDrawerPanel() {
      var panel = getPanel(el);
      if (!panel) return;
      try {
        panel.focus({ preventScroll: true });
      } catch (err) {
        panel.focus();
      }
    }

    function trapFocusAfterOpen() {
      if (typeof trapFocus !== 'function') return;

      var panel = getPanel(el);
      var focusTarget = el.classList.contains('is-empty')
        ? el.querySelector('.drawer__inner-empty') || el.querySelector('a')
        : document.getElementById('CartDrawer-Checkout');
      var trapRoot = el.querySelector('#CartDrawer') || panel;
      var closeButton = el.querySelector('.drawer__close, .rn-bag__header-close');

      if (focusTarget) trapFocus(trapRoot || focusTarget, closeButton);
      else if (trapRoot) trapFocus(trapRoot, closeButton);
    }

    function runThemeOpenSideEffects(triggerEl) {
      if (triggerEl && typeof el.setActiveElement === 'function') {
        el.setActiveElement(triggerEl);
      }

      if (typeof el.checkForClear === 'function') {
        el.checkForClear();
      }

      var timer = el.querySelector('countdown-timer');
      if (timer && typeof timer.playTimer === 'function') {
        timer.playTimer();
      }
    }

    function clearOpenTransitionHandler() {
      var panel = getPanel(el);
      if (panel && state.openTransitionHandler) {
        panel.removeEventListener('transitionend', state.openTransitionHandler);
        state.openTransitionHandler = null;
      }
    }

    function clearCloseTransitionHandler() {
      var panel = getPanel(el);
      if (panel && state.closeTransitionHandler) {
        panel.removeEventListener('transitionend', state.closeTransitionHandler);
        state.closeTransitionHandler = null;
      }
    }

    function openDrawer(triggerEl) {
      var panel = getPanel(el);
      if (!panel) return;

      if (state.closing || el.classList.contains('is-open')) {
        runThemeOpenSideEffects(triggerEl);
        return;
      }

      runThemeOpenSideEffects(triggerEl);
      state.lastFocused = document.activeElement;
      state.closing = false;
      clearCloseTransitionHandler();
      document.body.classList.remove('overflow-hidden');

      el.classList.remove('is-closing', 'active', 'animate', 'is-open');
      el.classList.add('is-opening');
      el.removeAttribute('hidden');
      document.documentElement.classList.add('rn-drawer-open');

      window.requestAnimationFrame(function () {
        void panel.offsetWidth;
        window.requestAnimationFrame(function () {
          el.classList.add('is-open');
          el.classList.remove('is-opening');
          focusDrawerPanel();
          alignBagLineCompareStrikes();
          if (document.fonts && document.fonts.ready) {
            document.fonts.ready.then(alignBagLineCompareStrikes);
          }
        });
      });

      lockPageScroll();
      bindDrawerScrollGuards();
      document.addEventListener('keydown', onKeyDown);

      window.setTimeout(function () {
        document.addEventListener('click', onDocumentClick, true);
        document.addEventListener('touchstart', onDocumentClick, true);
      }, 0);

      clearOpenTransitionHandler();
      state.openTransitionHandler = function (e) {
        if (e.target === panel && e.propertyName === 'transform') {
          clearOpenTransitionHandler();
          trapFocusAfterOpen();
        }
      };
      panel.addEventListener('transitionend', state.openTransitionHandler);
    }

    function closeDrawer() {
      var panel = getPanel(el);
      if (!panel) return;
      if (!el.classList.contains('is-open') || state.closing) return;

      state.closing = true;
      clearOpenTransitionHandler();

      el.classList.remove('is-open', 'active', 'animate', 'is-opening');
      el.classList.add('is-closing');
      // Resume page animations instantly (don't wait for the 700ms close tween).
      document.documentElement.classList.remove('rn-drawer-open');
      armGhostClickBlock();

      document.removeEventListener('keydown', onKeyDown);
      document.removeEventListener('click', onDocumentClick, true);
      document.removeEventListener('touchstart', onDocumentClick, true);
      unbindDrawerScrollGuards();

      var finished = false;
      function finishClose() {
        if (finished) return;
        finished = true;
        state.closing = false;
        el.classList.remove('is-closing', 'is-opening');
        el.setAttribute('hidden', '');
        document.documentElement.classList.remove('rn-drawer-open');
        if (typeof removeTrapFocus === 'function') {
          removeTrapFocus(el.activeElement);
        }
        unlockPageScroll();
        if (state.lastFocused && typeof state.lastFocused.focus === 'function') {
          try {
            state.lastFocused.focus({ preventScroll: true });
          } catch (err) {
            state.lastFocused.focus();
          }
        }
        clearCloseTransitionHandler();
      }

      clearCloseTransitionHandler();
      state.closeTransitionHandler = function (e) {
        if (e.target === panel && e.propertyName === 'transform') finishClose();
      };
      panel.addEventListener('transitionend', state.closeTransitionHandler);
      window.setTimeout(finishClose, DRAWER_MS + 50);
    }

    function onCloseButton(e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      closeDrawer();
    }

    function onKeyDown(e) {
      if (e.key === 'Escape' || e.keyCode === 27) {
        e.preventDefault();
        closeDrawer();
      }
    }

    function onDocumentClick(e) {
      if (!el.classList.contains('is-open')) return;
      var panel = getPanel(el);
      if (!panel) return;

      var target = e.target;
      var clickedInsidePanel = panel.contains(target);
      var clickedSpotlight = !!(
        target &&
        target.closest &&
        target.closest('[data-rn-bag-spotlight], .rn-bag-spotlight')
      );
      var clickedClose = target && target.closest
        ? target.closest('[data-drawer-close], .cart-drawer__overlay, .drawer__close, .rn-bag__header-close')
        : null;

      if (clickedSpotlight && !clickedClose) return;

      if (clickedClose || !clickedInsidePanel) {
        e.preventDefault();
        e.stopPropagation();
        closeDrawer();
      }
    }

    function bindOverlay() {
      var overlay = getOverlay(el);
      if (!overlay || overlay.dataset.rnBagOverlayBound === '1') return;
      overlay.dataset.rnBagOverlayBound = '1';
      overlay.setAttribute('data-drawer-close', '');
      overlay.addEventListener(
        'click',
        function (e) {
          e.preventDefault();
          e.stopImmediatePropagation();
          closeDrawer();
        },
        true
      );
    }

    function bindCloseDelegation() {
      if (el.dataset.rnBagCloseBound === '1') return;
      el.dataset.rnBagCloseBound = '1';
      el.addEventListener('click', function (e) {
        var closeBtn = e.target.closest('.drawer__close, .rn-bag__header-close');
        if (!closeBtn) return;
        onCloseButton(e);
      }, true);
      el.addEventListener('touchend', function (e) {
        var closeBtn = e.target.closest('.drawer__close, .rn-bag__header-close');
        if (!closeBtn) return;
        onCloseButton(e);
      }, { passive: false, capture: true });
    }

    bindOverlay();
    bindCloseDelegation();
    bindPlanPickers();

    return {
      open: openDrawer,
      close: closeDrawer,
      refresh: function () {
        bindOverlay();
        bindDrawerScrollGuards();
      },
    };
  }

  var planPickerDocBound = false;
  var planPickerClickBound = false;

  function getPlanToggleLabelEl(toggle) {
    return toggle ? toggle.querySelector('.rn-bag__line-plan-label') : null;
  }

  function cachePlanToggleDefaultLabel(toggle) {
    var label = getPlanToggleLabelEl(toggle);
    if (!toggle || !label) return;
    var defaultLabel = label.getAttribute('data-default-label') || label.textContent.trim();
    label.setAttribute('data-default-label', defaultLabel);
    toggle.dataset.defaultLabel = defaultLabel;
  }

  function setPlanToggleLabel(toggle, text) {
    var label = getPlanToggleLabelEl(toggle);
    if (!label) return;
    cachePlanToggleDefaultLabel(toggle);
    label.textContent = text;
  }

  function restorePlanToggleLabel(toggle) {
    var label = getPlanToggleLabelEl(toggle);
    if (!toggle || !label) return;
    var defaultLabel = toggle.dataset.defaultLabel || label.getAttribute('data-default-label');
    if (defaultLabel) label.textContent = defaultLabel;
  }

  function getPlanLoadingText(mode) {
    return mode === 'subscription' ? 'UPGRADING...' : 'DOWNGRADING...';
  }

  function closeAllPlanPickers(except) {
    document.querySelectorAll('.rn-bag__line-plan-picker').forEach(function (picker) {
      if (except && picker === except) return;

      var isLoading = picker.classList.contains('is-loading');
      var toggle = picker.querySelector('.rn-bag__line-plan-btn');
      var menu = picker.querySelector('.rn-bag__line-plan-menu');

      picker.classList.remove('is-open');

      if (toggle) {
        toggle.setAttribute('aria-expanded', 'false');
        if (!isLoading) {
          toggle.disabled = false;
          restorePlanToggleLabel(toggle);
        }
      }

      if (menu) menu.hidden = true;

      if (!isLoading) picker.classList.remove('is-loading');
    });
  }

  function bindPlanPickerDocumentClose() {
    if (planPickerDocBound) return;
    planPickerDocBound = true;
    document.addEventListener('click', function (e) {
      if (e.target.closest('.rn-bag__line-plan-picker')) return;
      closeAllPlanPickers();
    });
  }

  function handlePlanPickerClick(e) {
    var drawer = e.target.closest('cart-drawer.rn-bag');
    if (!drawer) return;

    var option = e.target.closest('.rn-bag__line-plan-option');
    if (option) {
      e.preventDefault();
      e.stopPropagation();

      var picker = option.closest('.rn-bag__line-plan-picker');
      var toggle = picker ? picker.querySelector('.rn-bag__line-plan-btn') : null;
      if (!picker || !toggle || picker.classList.contains('is-loading')) return;

      var line = toggle.getAttribute('data-line');
      var currentMode = toggle.getAttribute('data-mode');
      var mode = option.getAttribute('data-mode');
      var planId = option.getAttribute('data-selling-plan') || toggle.getAttribute('data-selling-plan');

      if (!line || !window.routes || !window.routes.cart_change_url) return;
      if (mode === currentMode) {
        closeAllPlanPickers();
        return;
      }

      var lineItem = picker.closest('.cart-item');
      var qtyInput = lineItem ? lineItem.querySelector('.quantity__input') : null;
      var quantity = qtyInput ? parseInt(qtyInput.value, 10) : 1;

      applySellingPlanChange(picker, line, quantity, mode, planId).catch(function () {
        /* error state restored in applySellingPlanChange */
      });
      return;
    }

    var toggle = e.target.closest('.rn-bag__line-plan-btn');
    if (!toggle) return;

    e.preventDefault();
    e.stopPropagation();

    var picker = toggle.closest('.rn-bag__line-plan-picker');
    if (!picker || picker.classList.contains('is-loading')) return;

    var menu = picker.querySelector('.rn-bag__line-plan-menu');
    var isOpen = picker.classList.contains('is-open');
    closeAllPlanPickers();
    if (!isOpen) {
      cachePlanToggleDefaultLabel(toggle);
      picker.classList.add('is-open');
      if (menu) menu.hidden = false;
      toggle.setAttribute('aria-expanded', 'true');
    }
  }

  function bindPlanPickers() {
    bindPlanPickerDocumentClose();
    if (planPickerClickBound) return;
    planPickerClickBound = true;
    document.addEventListener('click', handlePlanPickerClick);
  }

  function syncRnBagEmptyState(drawer, cartData) {
    if (!drawer || !drawer.classList) return;

    var hasItems = false;
    if (cartData && typeof cartData.item_count === 'number') {
      hasItems = cartData.item_count > 0;
    } else if (cartData && Array.isArray(cartData.items) && cartData.items.length > 0) {
      hasItems = true;
    } else {
      hasItems = !!drawer.querySelector(
        '.rn-bag__content-container .cart-item, .cart-drawer-item, [id^="CartDrawer-Item-"]'
      );
      if (!hasItems && drawer.querySelector('.rn-bag__content-container') && !drawer.querySelector('.drawer__inner-empty')) {
        hasItems = true;
      }
    }

    drawer.classList.toggle('is-empty', !hasItems);
    alignBagLineCompareStrikes();
  }

  function alignBagLineCompareStrike(el) {
    if (window.rnAlignPriceStrike) window.rnAlignPriceStrike(el);
  }

  function alignBagLineCompareStrikes() {
    document.querySelectorAll('cart-drawer.drawer.rn-bag .rn-bag__line-prices s, cart-drawer.drawer.rn-bag .cart-item__price s, cart-drawer.drawer.rn-bag .rn-bag__summary-value--compare s, cart-drawer.drawer.rn-bag .rn-bag-spotlight__price-compare').forEach(alignBagLineCompareStrike);
  }

  function refreshRnBagAfterCartMutation() {
    document.querySelectorAll('cart-drawer.rn-bag').forEach(function (el) {
      if (el._rnBagController) {
        el._rnBagController.refresh();
      } else {
        initRnBagDrawer(el);
      }
    });
  }

  function bindThemeCartUpdates() {
    if (window.__rnBagCartUpdatesBound || typeof subscribe !== 'function') return;
    window.__rnBagCartUpdatesBound = true;
    subscribe('cart-update', refreshRnBagAfterCartMutation);
    subscribe('quantity-update', refreshRnBagAfterCartMutation);
  }

  function getCartSectionIds() {
    var ids = ['cart-drawer', 'cart-icon-bubble'];
    var drawer = document.querySelector('cart-drawer');

    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      drawer.getSectionsToRender().forEach(function (section) {
        if (section && section.id) ids.push(section.id);
      });
    }

    document.querySelectorAll('cart-drawer, cart-icon-bubble, #cart-icon-bubble').forEach(function (node) {
      var section = node.closest('[id^="shopify-section-"]');
      if (section && section.id) ids.push(section.id.replace('shopify-section-', ''));
    });

    return ids.filter(function (id, index, list) {
      return list.indexOf(id) === index;
    });
  }

  function getCartRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function fetchCartSections() {
    return fetch(getCartRoot() + 'cart?sections=' + getCartSectionIds().join(','), {
      headers: { Accept: 'application/json' },
    }).then(function (response) {
      if (!response.ok) throw new Error('cart sections refresh failed');
      return response.json();
    });
  }

  function fetchCartJs() {
    return fetch(getCartRoot() + 'cart.js', {
      headers: { Accept: 'application/json' },
    }).then(function (response) {
      if (!response.ok) throw new Error('cart.js failed');
      return response.json();
    });
  }

  function applyCartIconFromSections(sections) {
    var currentIcon = document.getElementById('cart-icon-bubble');
    var iconHtml = sections && sections['cart-icon-bubble'];
    if (typeof iconHtml !== 'string' || !currentIcon) return;
    var iconParsed = new DOMParser().parseFromString(iconHtml, 'text/html');
    var freshIcon = iconParsed.querySelector('#cart-icon-bubble') || iconParsed.body.firstElementChild;
    if (freshIcon) currentIcon.innerHTML = freshIcon.innerHTML;
  }

  function applyRnBagPanelFromSections(sections, cartData) {
    var html = sections && sections['cart-drawer'];
    if (typeof html !== 'string' || !html.trim()) return false;

    var parsed = new DOMParser().parseFromString(html, 'text/html');
    var nextInner = parsed.querySelector('cart-drawer .drawer__inner, .drawer__inner');
    var currentInner = document.querySelector('cart-drawer.rn-bag .drawer__inner');
    if (!nextInner || !currentInner) return false;

    currentInner.innerHTML = nextInner.innerHTML;

    var drawer = document.querySelector('cart-drawer.rn-bag');
    if (drawer) {
      drawer.classList.add('is-open');
      drawer.removeAttribute('hidden');
      syncRnBagEmptyState(drawer, cartData);
    }

    applyCartIconFromSections(sections);
    refreshRnBagAfterCartMutation();
    return true;
  }

  function hideSpotlightCard(variantId, productId) {
    var spotlight = document.querySelector('[data-rn-bag-spotlight]');
    if (!spotlight || spotlight.getAttribute('data-hide-in-cart') !== 'true') return;

    var card = null;
    if (productId) {
      card = spotlight.querySelector('.rn-bag-spotlight__card[data-product-id="' + productId + '"]');
    }
    if (!card && variantId) {
      card = spotlight.querySelector('.rn-bag-spotlight__card[data-variant-id="' + variantId + '"]');
    }
    if (!card) return;

    card.classList.add('is-added');
    card.setAttribute('hidden', '');
    card.setAttribute('aria-hidden', 'true');

    var wrap = spotlight.querySelector('.rn-bag-spotlight__cards');
    if (!wrap) return;

    var visible = 0;
    wrap.querySelectorAll('.rn-bag-spotlight__card').forEach(function (el) {
      if (el.classList.contains('is-added') || el.hasAttribute('hidden')) return;
      visible += 1;
    });
    wrap.setAttribute('data-count', String(visible));
    if (visible === 0) {
      spotlight.setAttribute('hidden', '');
      spotlight.setAttribute('aria-hidden', 'true');
    }
  }

  function renderCartSectionsFromResponse(cartData) {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || !cartData || !cartData.sections) return false;

    if (typeof drawer.renderContents === 'function') {
      try {
        drawer.renderContents(cartData);
        restoreRnBagItemsFromSection(cartData);
        return true;
      } catch (err) {}
    }

    var sectionHtml = cartData.sections['cart-drawer'];
    if (typeof sectionHtml !== 'string' || !sectionHtml.trim()) return false;

    var parsed = new DOMParser().parseFromString(sectionHtml, 'text/html');
    var nextDrawer = parsed.querySelector('#CartDrawer');
    var currentDrawer = document.getElementById('CartDrawer');

    if (nextDrawer && currentDrawer) {
      currentDrawer.innerHTML = nextDrawer.innerHTML;
      restoreRnBagItemsFromSection(cartData);
      return true;
    }

    return false;
  }

  function restoreRnBagItemsFromSection(cartData) {
    var html = cartData && cartData.sections && cartData.sections['cart-drawer'];
    if (typeof html !== 'string' || !html.trim()) return;
    var parsed = new DOMParser().parseFromString(html, 'text/html');
    var nextItems = parsed.querySelector('cart-drawer.rn-bag cart-drawer-items, cart-drawer-items');
    var currentItems = document.querySelector('cart-drawer.rn-bag cart-drawer-items');
    if (!nextItems || !currentItems) return;
    if (currentItems.querySelector('.title--primary, .cart__empty-text, .cart__warnings')) {
      currentItems.innerHTML = nextItems.innerHTML;
    }

    applyCartIconFromSections(cartData.sections);
  }

  function refreshCartAfterPlanChange(cartData) {
    var drawer = document.querySelector('cart-drawer.rn-bag');
    var wasOpen = !!(drawer && drawer.classList.contains('is-open'));

    if (!renderCartSectionsFromResponse(cartData)) {
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      return fetch(root + 'cart?sections=' + getCartSectionIds().join(','))
        .then(function (response) {
          if (!response.ok) throw new Error('cart sections refresh failed');
          return response.json();
        })
        .then(function (sections) {
          cartData.sections = Object.assign({}, cartData.sections || {}, sections);
          renderCartSectionsFromResponse(cartData);
        });
    }

    return Promise.resolve();
  }

  function applySellingPlanChange(picker, line, quantity, mode, planId) {
    var toggle = picker.querySelector('.rn-bag__line-plan-btn');
    var menu = picker.querySelector('.rn-bag__line-plan-menu');
    var drawer = document.querySelector('cart-drawer.rn-bag');
    var wasOpen = !!(drawer && drawer.classList.contains('is-open'));
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var body = {
      line: parseInt(line, 10),
      quantity: quantity || 1,
      sections: getCartSectionIds(),
      sections_url: root + 'cart',
    };

    if (mode === 'subscription' && planId) {
      body.selling_plan = parseInt(planId, 10);
    } else {
      body.selling_plan = null;
    }

    closeAllPlanPickers(picker);
    picker.classList.remove('is-open');
    picker.classList.add('is-loading');
    if (menu) menu.hidden = true;
    if (toggle) {
      toggle.disabled = true;
      toggle.setAttribute('aria-expanded', 'false');
      setPlanToggleLabel(toggle, getPlanLoadingText(mode));
    }

    return fetch(window.routes.cart_change_url + '.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify(body),
    })
      .then(function (response) {
        if (!response.ok) throw new Error('cart change failed');
        return response.json();
      })
      .then(function (cartData) {
        return refreshCartAfterPlanChange(cartData);
      })
      .then(function () {
        if (wasOpen && drawer) {
          drawer.classList.add('is-open');
          drawer.removeAttribute('hidden');
        }
        refreshRnBagAfterCartMutation();
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      })
      .catch(function () {
        picker.classList.remove('is-loading');
        if (toggle) {
          toggle.disabled = false;
          restorePlanToggleLabel(toggle);
        }
        throw new Error('cart plan change failed');
      });
  }

  function initRnBagDrawer(el) {
    if (!el || !el.classList.contains('rn-bag')) return null;

    if (el.parentNode !== document.body) {
      document.body.appendChild(el);
    }

    if (!el._rnBagController) {
      el._rnBagController = createDrawerController(el);
      el.open = function (triggerEl) {
        el._rnBagController.open(triggerEl);
      };
      el.close = function () {
        el._rnBagController.close();
      };
      el.dataset.rnBagInit = '1';
    } else {
      el._rnBagController.refresh();
    }

    if (el.classList.contains('is-open') || el.classList.contains('is-closing') || el.classList.contains('is-opening')) {
      el.removeAttribute('hidden');
      return el._rnBagController;
    }

    if (el.classList.contains('active') && !el.hasAttribute('hidden')) {
      el.classList.remove('active', 'animate');
      el._rnBagController.open();
      return el._rnBagController;
    }

    el.classList.remove('active', 'animate');
    if (!el.hasAttribute('hidden')) {
      el.setAttribute('hidden', '');
    }

    return el._rnBagController;
  }

  function patchCartDrawerPrototype() {
    if (!window.customElements || !customElements.get('cart-drawer')) return false;
    var CartDrawer = customElements.get('cart-drawer');
    if (CartDrawer.prototype.__rnBagPatched) return true;

    var originalOpen = CartDrawer.prototype.open;
    var originalClose = CartDrawer.prototype.close;

    CartDrawer.prototype.open = function (triggerEl) {
      if (this.classList && this.classList.contains('rn-bag')) {
        var controller = initRnBagDrawer(this);
        return controller.open(triggerEl);
      }
      return originalOpen.call(this, triggerEl);
    };

    CartDrawer.prototype.close = function () {
      if (this.classList && this.classList.contains('rn-bag')) {
        var controller = initRnBagDrawer(this);
        return controller.close();
      }
      return originalClose.call(this);
    };

    CartDrawer.prototype.__rnBagPatched = true;

    if (!CartDrawer.prototype.__rnBagRenderPatched && typeof CartDrawer.prototype.renderContents === 'function') {
      var originalRenderContents = CartDrawer.prototype.renderContents;
      CartDrawer.prototype.renderContents = function (cartData) {
        var result = originalRenderContents.apply(this, arguments);
        if (this.classList && this.classList.contains('rn-bag')) {
          // Theme only swaps #CartDrawer HTML — is-empty on <cart-drawer> must be synced
          // or .rn-bag__content-container stays display:none after add-from-empty.
          syncRnBagEmptyState(this, cartData);
          refreshRnBagAfterCartMutation();
        }
        return result;
      };
      CartDrawer.prototype.__rnBagRenderPatched = true;
    }

    return true;
  }

  function openRnBag(triggerEl) {
    var drawer = document.querySelector('cart-drawer.rn-bag');
    if (!drawer) return false;
    var controller = initRnBagDrawer(drawer);
    var trigger = triggerEl || document.getElementById('cart-icon-bubble');
    if (controller && typeof controller.open === 'function') {
      controller.open(trigger);
      return true;
    }
    if (typeof drawer.open === 'function') {
      drawer.open(trigger);
      return true;
    }
    return false;
  }

  window.RnBagOpen = openRnBag;

  function bindCartIconTrigger() {
    if (window.__rnBagIconBound) return;
    window.__rnBagIconBound = true;
    document.addEventListener(
      'click',
      function (e) {
        var trigger =
          e.target && e.target.closest
            ? e.target.closest('#cart-icon-bubble, a.header__icon--cart[data-rn-bag-trigger], [data-rn-bag-trigger]')
            : null;
        if (!trigger) return;
        e.preventDefault();
        e.stopPropagation();
        openRnBag(trigger);
      },
      true
    );
  }

  function flushPendingBagOpen() {
    try {
      // Clear any stale flag from older cart-bounce builds (could loop-open on Safari).
      sessionStorage.removeItem('rn-open-bag');
    } catch (e) {}

    if (!window.__rnBagPendingOpen) return;
    window.__rnBagPendingOpen = false;
    window.requestAnimationFrame(function () {
      openRnBag(document.getElementById('cart-icon-bubble'));
    });
  }

  function addSpotlightProduct(btn) {
    if (!btn || btn.disabled || btn.classList.contains('is-loading')) return;
    var variantId = btn.getAttribute('data-variant-id');
    var productId = btn.getAttribute('data-product-id');
    if (!variantId) return;

    var label = btn.querySelector('.rn-bag-spotlight__add-label');
    var prevLabel = label ? label.innerHTML : '';
    btn.disabled = true;
    btn.classList.add('is-loading');
    btn.setAttribute('aria-busy', 'true');
    if (label) label.textContent = 'Adding…';

    var root = getCartRoot();
    var drawer = document.querySelector('cart-drawer.rn-bag');

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: Number(variantId), quantity: 1 }],
        sections: getCartSectionIds(),
        sections_url: root + 'cart',
      }),
    })
      .then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok) throw new Error((data && (data.description || data.message)) || 'Cart add failed');
          return data;
        });
      })
      .then(function (addData) {
        return Promise.all([fetchCartJs(), fetchCartSections()]).then(function (results) {
          var cart = results[0];
          var sections = results[1];
          var merged = Object.assign({}, addData || {}, cart || {});
          merged.sections = Object.assign({}, (addData && addData.sections) || {}, sections || {});

          if (drawer) {
            drawer.classList.remove('is-empty');
            drawer.classList.add('is-open');
            drawer.removeAttribute('hidden');
          }

          if (!applyRnBagPanelFromSections(merged.sections, cart)) {
            renderCartSectionsFromResponse(merged);
            if (drawer) syncRnBagEmptyState(drawer, cart);
          }
          hideSpotlightCard(variantId, productId);
        });
      })
      .catch(function (err) {
        console.error(err);
        if (label) {
          label.textContent = 'Error';
          window.setTimeout(function () {
            if (label) label.innerHTML = prevLabel;
          }, 1600);
        }
      })
      .finally(function () {
        var liveBtn = document.querySelector(
          '[data-rn-bag-spotlight-add][data-variant-id="' + variantId + '"]'
        );
        if (liveBtn) {
          liveBtn.disabled = false;
          liveBtn.classList.remove('is-loading');
          liveBtn.setAttribute('aria-busy', 'false');
          var liveLabel = liveBtn.querySelector('.rn-bag-spotlight__add-label');
          if (liveLabel && liveLabel.textContent === 'Adding…') liveLabel.innerHTML = prevLabel;
        }
      });
  }

  function bindSpotlightAdds() {
    if (window.__rnBagSpotlightBound) return;
    window.__rnBagSpotlightBound = true;
    document.addEventListener(
      'click',
      function (e) {
        var btn = e.target && e.target.closest ? e.target.closest('[data-rn-bag-spotlight-add]') : null;
        if (!btn) return;
        e.preventDefault();
        e.stopPropagation();
        addSpotlightProduct(btn);
      },
      true
    );
  }

  function enhanceAll() {
    patchCartDrawerPrototype();
    bindPlanPickers();
    bindThemeCartUpdates();
    bindCartIconTrigger();
    bindSpotlightAdds();
    document.querySelectorAll('cart-drawer.rn-bag').forEach(initRnBagDrawer);
    flushPendingBagOpen();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhanceAll);
  } else {
    enhanceAll();
  }

  if (window.customElements && customElements.whenDefined) {
    customElements.whenDefined('cart-drawer').then(enhanceAll);
  }

  document.addEventListener('shopify:section:load', enhanceAll);
  document.documentElement.addEventListener('cart:refresh', enhanceAll);
  document.addEventListener('cart:refresh', enhanceAll);
})();
